
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/[plan]",
      function () {
        return require("private-next-pages/pricing/[plan].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/[plan]"])
      });
    }
  